import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { TopicLifecycleDTO } from '../../services/tutorLifecycleService';

interface Props {
  lifecycle: TopicLifecycleDTO;
}

export default function StudentTopicLifecycleBadge({ lifecycle }: Props) {
  if (lifecycle.state === 'NONE') return null;

  if (lifecycle.state === 'SCHEDULED') {
    return (
      <Tooltip title={`Planned: ${lifecycle.plannedDate}`}>
        <Chip
          icon={<EventIcon />}
          label={`Planned ${lifecycle.plannedDate}`}
          size="small"
          color="info"
          variant="outlined"
        />
      </Tooltip>
    );
  }

  if (lifecycle.state === 'STARTED') {
    return (
      <Tooltip title={`Teaching started: ${lifecycle.startedDate}`}>
        <Chip
          icon={<PlayCircleOutlineIcon />}
          label={`Teaching started ${lifecycle.startedDate}`}
          size="small"
          color="primary"
          variant="outlined"
        />
      </Tooltip>
    );
  }

  if (lifecycle.state === 'COMPLETED') {
    return (
      <Tooltip title={`Teaching completed: ${lifecycle.completedDate}`}>
        <Chip
          icon={<CheckCircleOutlineIcon />}
          label={`Teaching completed ${lifecycle.completedDate}`}
          size="small"
          color="success"
          variant="outlined"
        />
      </Tooltip>
    );
  }

  return null;
}
